// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CCcv","right":"styles_right__1m4_z"};